module.exports = __webpack_public_path__ + "static/media/LandingImage.b0a676eb.png";